import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import styles from './ReservationCreatedModal.module.css';


function ReservationCreatedModal(props) {
  
  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const setting = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);

  const formatToFloat = (number) => {
    return number ? Number(number).toFixed(2) : '0.00';
  };

  const labelAndValueComponent = ({label, value, index}) => (
    <p key={index}>
      <span className={styles.firstColumn}>{label}</span>
      <span>{value}</span>
    </p>
  );

  const getGuestsNumber = (noOfGuests, noOfAdults, noOfChildren) => {
    if (noOfChildren) {
      return (
        <>
          <span>{noOfGuests}</span>
          <span className={styles.guestsNumber}>{`(${noOfAdults} adults, ${noOfChildren} child)`}</span>
        </>
      );
    };
    return (
      <>
        <span>{noOfGuests}</span>
        <span className={styles.guestsNumber}>{`(${noOfAdults} adults)`}</span>
      </>
    );
  };
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const getGuestNameByBookingTitle = (bookingName) => {
    return bookingName.split('|')[0].trim();
  };

  const labelAndValueList = [
    { label: 'Rental:',           value: bookingData?.rentalId       && getRentalNameById(bookingData.rentalId) },
    { label: 'Name:',             value: bookingData?.title          && getGuestNameByBookingTitle(bookingData.title) },
    { label: 'Arrival date:',     value: bookingData?.arrive         && moment(bookingData?.arrive).format('DD MMMM YYYY') },
    { label: 'Departure date:',   value: bookingData?.depart         && moment(bookingData?.depart).format('DD MMMM YYYY') },
    { label: 'Total nights:',     value: bookingData?.nights },
    { label: 'Guests:',           value: bookingData?.noOfGuests     && bookingData?.noOfAdults && getGuestsNumber(bookingData.noOfGuests, bookingData.noOfAdults, bookingData.noOfChildren) },
    { label: 'Adults:',           value: bookingData?.noOfAdults },
    { label: 'Total:',            value: bookingData?.price          && formatToFloat(bookingData.price) },
    { label: 'Received:',         value: bookingData?.createdAt      && moment(bookingData?.createdAt).format('DD MMM YYYY hh:mm a') },
  ];

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
          >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>The following reservation was received:</p>
        <div className={styles.contentContainer}>
          { labelAndValueList.map((item, index)=> labelAndValueComponent({
            index: index,
            label: item.label,
            value: item.value,
          }))}
        </div>
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ReservationCreatedModal;